export async function getWorkshops(booking:Booking) {
    console.log('get-workshops.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'workshops';

    let data = new FormData();
    data.append('booking', JSON.stringify(booking));

    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                console.log(result)
                return result
            },
            (error) => {
                return {error:error}
            }
        );
}
